/**
 * @generated SignedSource<<cc785e0c3f0bec1ff8365a48f7044b08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountLinkId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountLinkUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountLinkTPayload",
        "kind": "LinkedField",
        "name": "updateAccountLinkTByAccountLinkId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountLinkT",
            "kind": "LinkedField",
            "name": "accountLinkT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountLinkUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountLinkTPayload",
        "kind": "LinkedField",
        "name": "updateAccountLinkTByAccountLinkId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountLinkT",
            "kind": "LinkedField",
            "name": "accountLinkT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4efc8cda911e72e8ad7b2395aeb0ddab",
    "id": null,
    "metadata": {},
    "name": "AccountLinkUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AccountLinkUpdateMutation(\n  $input: UpdateAccountLinkTByAccountLinkIdInput!\n) {\n  updateAccountLinkTByAccountLinkId(input: $input) {\n    accountLinkT {\n      accountLinkId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "39827a0e350cabd6f4ff876dabcf3c58";

module.exports = node;
